import Vue from 'vue';
import axios from 'axios'
import ElementUI from 'element-ui';
import store from '../store'
import {getToken} from '@/utils/auth'
import {getOrgId} from '@/utils/auth'
// import {getToken_refresh} from '@/api/users'
import {logintoken} from '@/api/login'
import router from '../router';
import Bus from "@/utils/bus";

// 创建axios实例
const service = axios.create({
  // baseURL: 'https://172.21.56.125:8086/',
  baseURL: '/api',
  timeout: 3*60*1000 // 请求超时时间
})
const service1 = axios.create({
  // baseURL: 'https://172.21.56.125:8086/',
  baseURL: '/api',
  timeout: 3*60*1000 // 请求超时时间
})
/*是否有请求正在刷新token*/
window.isRefreshing = false
/*被挂起的请求数组*/
let refreshSubscribers = []

// /*获取刷新token请求的token*/
// function getRefreshToken() {
//     return localStorage.getItem("refresh_token")
// }

/*push所有请求到数组中*/
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb)
}

/*刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）*/
function onRrefreshed(token) {
  refreshSubscribers.map(cb => cb(token))
}

// request 请求拦截器
service.interceptors.request.use(config => {
  //有时候不传params报错
  //   if(process.env.NODE_ENV !== 'development'&&config.url.indexOf("/gw")===-1){
  //       config.url = "/gw"+config.url;
  //   }
  // console.log(config)
  config.params = config.params || {};
  // if (getToken() && config.url.indexOf("/open")===-1) { // 有token但是接口路径带open不需要token
  if (getToken()) { // 有token
    config.headers['Blade-Auth'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    /*判断token是否将要过期*/
    // alert(countDown()+"判断是否true");
    // var istoken = countDown();
    if (isTokenExpired()) {
      // debugger
      ElementUI.Notification({
        showClose: true,
        message: '登录超时，请重新登录。',
        type: 'error'
      });
      Bus.$emit('re-login', '登录超时')
      // router.push({path: '/home'})
      // debugger
      return

      /*判断是否正在刷新*/
      if (!window.isRefreshing) {
        /*将刷新token的标志置为true*/
        window.isRefreshing = true
        /*发起刷新token的请求*/

        var params = {
          refreshToken: localStorage.getItem('refresh_Token'),
          grantType:"password",
          tenantId:"000000",
        };
        logintoken(params).then((res) => {
          /*将标志置为false*/
          window.isRefreshing = false
          /*成功刷新token*/
          // config.headers.Authorization = res.data.data.token_type + ' ' + res.data.data.token
          /*更新auth*/
          if (res.data.code == 0) {
            ElementUI.Notification({
              showClose: true,
              message: '登录超时，请重新登录。',
              type: 'error'
            });
            // router.push({path: '/login'})
            localStorage.removeItem('Token');
            localStorage.removeItem('refresh_Token');
            localStorage.removeItem('name');
            localStorage.removeItem('router');
            localStorage.removeItem('expires_in');
            localStorage.removeItem('lockingTime');
            localStorage.removeItem('stationOpenService');
            window.location.reload(); // 刷新页面
            return
          }
          if(res.data.code==200){
            localStorage.setItem('Token', res.data.data.accessToken); // 令牌
            localStorage.setItem('refresh_Token', res.data.data.refreshToken); //刷新令牌
            localStorage.setItem('expires_in', res.data.data.expiresIn); //过期时间
            localStorage.setItem('expires_at', new Date().getTime() + res.data.data.expiresIn * 1000); //获取token的当前时间
          }


          /*执行数组里的函数,重新发起被挂起的请求*/
          onRrefreshed(res.data.data.access_token)
          /*执行onRefreshed函数后清空数组中保存的请求*/
          refreshSubscribers = []
        }).catch(err => {
          // alert(err.response.data.message)
          /*清除本地保存的auth*/
          // localStorage.removeItem('auth')
          // window.location.href = '/station/login'
          // router.push({path: '/login'})
        })
      }
      /*把请求(token)=>{....}都push到一个数组中*/
      let retry = new Promise((resolve, reject) => {
        /*(token) => {...}这个函数就是回调函数*/
        subscribeTokenRefresh((token) => {
          // config.headers.Authorization = 'Bearer ' + token
          config.params['access_token'] = token
          /*将请求挂起*/
          resolve(config)
        })
      })
      return retry
    }
  } else {
    // router.push({path: '/login'})
  }
  return config
}, error => {
  Promise.reject(error)
})

// response 响应拦截器
service.interceptors.response.use(
  response => {
    // debugger
    // console.log("______响应请求拦截______" + JSON.stringify(response))
    if (response.status !== 200) {
      if (response.status === 500) { // 服务器断开
        ElementUI.Notification({
          showClose: true,
          message: '服务器断开，请稍后重试。',
          type: 'error'
        });
      }
      return Promise.reject(new Error(response.message || 'Error'))
    } else {
      return response
    }
  }, error => {
    if (error && error.stack.indexOf('timeout') > -1) {
      ElementUI.Notification({
        showClose: true,
        message: '请求超时',
        type: 'error'
      });
      const loadingAll = ElementUI.Loading.service({//请求超时，关闭页面弹窗
        lock: true,
        text: '',
        spinner: 'icon-null',
        background: 'rgba(0, 0, 0, 0)'
      });
      loadingAll.close();
    }
    console.log("______error____" + error.response)
      // debugger
    if (error.response.status === 401) { // token失效 ,重新获取token
      ElementUI.Notification({
        showClose: true,
        message: '登录超时，请重新登录。',
        type: 'error'
      });
      router.push({path: '/home'}) // 去首页
      Bus.$emit('re-login', 'token失效')
      localStorage.removeItem('Token');
      localStorage.removeItem('refresh_Token');
      localStorage.removeItem('name');
      localStorage.removeItem('router');
      // window.location.reload(); //刷新页面
      return
      var params = {
        refreshToken: localStorage.getItem('refresh_Token'),
        grantType:"password",
        tenantId:"000000",
      };
      logintoken(params).then((res) => {
        // /*更新auth*/
        // if (res.data.code == 0) {  //暂时屏蔽，多个接口影响，后期会恢复
        //     ElementUI.Notification({
        //       showClose: true,
        //       message: '登录超时，请重新登录。',
        //       type: 'error'
        //     });
        //     localStorage.removeItem('Token');
        //     localStorage.removeItem('refresh_Token');
        //     localStorage.removeItem('name');
        //     localStorage.removeItem('router');
        //     window.location.reload();// 刷新页面
        //     return
        // }
        if(res.data.code == 200){
          localStorage.setItem('Token', res.data.data.accessToken); // 令牌
          localStorage.setItem('refresh_Token', res.data.data.refreshToken); //刷新令牌
          localStorage.setItem('expires_in', res.data.data.expiresIn); //过期时间
          localStorage.setItem('expires_at', new Date().getTime() + res.data.data.expiresIn * 1000); //获取token的当前时间
        }

      }).catch(err => {
        // window.location.href = '/staiton/login'
        // router.push({path: '/login'})
      })
    }
    return error.response
    // return Promise.reject(error.response)
  }
)

/*判断token是否过期*/
function isTokenExpired() {
  let expiredTime = new Date().getTime();
  /*从localStorage中取出token过期时间*/
  if (localStorage.getItem("expires_in") != undefined && localStorage.getItem("expires_in") != "undefined") {

    expiredTime = localStorage.getItem("expires_at") // token过期的时间戳
    // expiredTime = new Date(localStorage.getItem("expires_at")).getTime() / 1000
  }
  /*获取本地时间*/
  let nowTime = new Date().getTime()
  // debugger
  /*获取校验时间差*/
  // let diffTime = JSON.parse(sessionStorage.diffTime)
  // let diffTime = 10000;
  /*校验本地时间*/
  // nowTime -= diffTime
  // alert(expiredTime - nowTime);
  /*如果 < 10分钟，则说明即将过期*/
  var flag = (expiredTime - nowTime) < 10 * 60;
  // return (expiredTime - nowTime) < 10*60;
  return flag;
}

// var i = localStorage.getItem('expires_in');
// //token有效期倒计时
// function countDown(){
//   // console.log("倒计时--------" +i)
//   i = i-1;
//   if(i>600){
//     setTimeout(function () {
//       //递归
//       countDown();
//     }, 1000)
//     return false;
//   }else{
//     return true;
//   }
// }


export default service
